import { TranslationKeyPrefix, useTranslations } from 'hooks/useTranslations'
import Stepper from 'components/Stepper'
import { useRouter } from 'next/router'

export interface MinimalHeaderProps {
  hideWhenLoggedIn: boolean
  userLoggedIn: boolean
}

type Page =
  | 'signup'
  | 'welcome'
  | 'confirm-details'
  | 'address'
  | 'id-verification'
  | 'security-questions'

const stepMapping: Record<Page, number> = {
  signup: 1,
  welcome: 1,
  'confirm-details': 1,
  address: 2,
  'id-verification': 3,
  'security-questions': 4,
}

export const MinimalHeader = () => {
  const { getTranslationLiteral: tl } = useTranslations(TranslationKeyPrefix.AccountCreation)

  const router = useRouter()
  const currentPage = router.pathname.split('/').pop() as Page
  const currentStep = stepMapping[currentPage] || 0

  const steps = [tl('stepper.step1'), tl('stepper.step2'), tl('stepper.step3'), tl('stepper.step4')]

  return (
    <div>
      <Stepper activeStep={currentStep} steps={steps} />
      {/* 
          Mimecast Brand Exploit Web Agent Script AKA Ping Tracker integration
          Full context: https://christiestech.atlassian.net/wiki/spaces/CT/pages/2853798123/Ping+Tracker+Implementation
        */}
      <script
        async
        src="https://static.srcspot.com/libs/ida.js"
        type="application/javascript"
      ></script>
    </div>
  )
}
